import React from 'react';
import { injectIntl } from 'react-intl';
import Paragraph from '../../../atoms/paragraphs/Paragraph';
import Button from '../../../atoms/buttons/Button';
import SelectWithValues from '../../../atoms/selects/SelectWithValues';

const SubscriptionExpiredContent = ({ intl, ...props }) => {
  const { currentFlow, userAccounts, selectedAccount, onAccountChange } = props;

  return (
    <div className='d-flex flex-column w-100'>
      <div className='d-flex flex-column-reverse w-100 h-100 justify-content-between'>
        <div className='d-flex flex-column col-12 px-0 gap-2'>
          {selectedAccount?.key !== 'Loading...' && (
            <Paragraph className='text-header regular black f32 text-center mt-0 mb-4'>
              {selectedAccount.key}
            </Paragraph>
          )}
          <Paragraph className='text-header error h3 text-center mt-0 mb-4'>
            {intl.messages[`blockedPageTitle_${currentFlow}`]}
          </Paragraph>
          <Button
            label={intl.messages['subscribePlanButton']}
            className='button button-primary mt-2 mb-2 m-auto'
            onClick={() => {
              window.location.href = '/accounts/checkout';
            }}
          />
          <div className='d-flex flex-column flex-md-row justify-content-between mt-4 mb-0'>
            <div className='d-flex flex-row w-100 mb-3 mb-md-0'>
              <div className='d-flex w-auto'>
                <Paragraph className='text-paragraph nowrap w-100 my-auto me-3'>
                  {intl.messages['changeAccountLabel']}
                </Paragraph>
              </div>

              <SelectWithValues
                options={userAccounts}
                className='select-primary my-auto w-100 me-md-3'
                value={selectedAccount.value}
                onChange={(e) => onAccountChange(e.target.value)}
              />
            </div>

            <div className='d-flex flex-row m-auto'>
              <div className='logout-icon m-auto me-2'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='21'
                  height='22'
                  viewBox='0 0 21 22'
                  fill='none'
                >
                  <path
                    d='M16.3261 2.98276C18.0515 4.21394 19.341 5.96106 20.0086 7.97213C20.6763 9.98319 20.6875 12.1542 20.0408 14.1721C19.3941 16.19 18.1228 17.9504 16.4102 19.1994C14.6977 20.4484 12.6325 21.1214 10.5125 21.1214C8.39255 21.1214 6.32735 20.4484 4.61484 19.1994C2.90232 17.9504 1.631 16.19 0.984264 14.1721C0.337525 12.1542 0.348795 9.98319 1.01645 7.97213C1.6841 5.96106 2.97362 4.21394 4.69901 2.98276C4.81043 2.90297 4.93749 2.84765 5.07183 2.82044C5.20617 2.79323 5.34475 2.79473 5.47847 2.82486C5.61218 2.85499 5.73801 2.91306 5.84767 2.99526C5.95733 3.07745 6.04835 3.18191 6.11474 3.30176L6.75208 4.43476C6.86743 4.63982 6.90404 4.87987 6.85505 5.10997C6.80607 5.34006 6.67483 5.54442 6.48594 5.68476C5.33962 6.53277 4.49016 7.72058 4.05846 9.07912C3.62677 10.4377 3.63485 11.8977 4.08155 13.2514C4.52826 14.605 5.39081 15.7834 6.54645 16.6187C7.70208 17.4539 9.09189 17.9036 10.518 17.9036C11.9442 17.9036 13.334 17.4539 14.4896 16.6187C15.6453 15.7834 16.5078 14.605 16.9545 13.2514C17.4012 11.8977 17.4093 10.4377 16.9776 9.07912C16.5459 7.72058 15.6965 6.53277 14.5501 5.68476C14.362 5.54468 14.2316 5.34075 14.1833 5.11131C14.135 4.88187 14.1723 4.6427 14.288 4.43876L14.9193 3.30176C14.9858 3.18397 15.0762 3.08142 15.1848 3.00073C15.2934 2.92004 15.4177 2.86301 15.5497 2.83333C15.6817 2.80364 15.8185 2.80196 15.9512 2.82839C16.0839 2.85482 16.2095 2.90877 16.3201 2.98676L16.3261 2.98276ZM12.1299 11.4468V1.76976C12.1303 1.64262 12.1055 1.51665 12.0571 1.39909C12.0086 1.28153 11.9374 1.17471 11.8474 1.08476C11.7575 0.994802 11.6507 0.923494 11.5332 0.874929C11.4156 0.826363 11.2896 0.801498 11.1624 0.801762H9.8717C9.7444 0.801366 9.61829 0.826134 9.5006 0.87464C9.38292 0.923146 9.276 0.994434 9.18598 1.0844C9.09597 1.17437 9.02464 1.28123 8.97611 1.39886C8.92758 1.51648 8.9028 1.64253 8.9032 1.76976V11.4468C8.9028 11.574 8.92758 11.7 8.97611 11.8177C9.02464 11.9353 9.09597 12.0422 9.18598 12.1321C9.276 12.2221 9.38292 12.2934 9.5006 12.3419C9.61829 12.3904 9.7444 12.4152 9.8717 12.4148H11.1624C11.2897 12.4152 11.4158 12.3904 11.5335 12.3419C11.6512 12.2934 11.7581 12.2221 11.8481 12.1321C11.9381 12.0422 12.0094 11.9353 12.058 11.8177C12.1065 11.7 12.1313 11.574 12.1309 11.4468H12.1299Z'
                    fill='#C11A1A'
                  />
                </svg>
              </div>

              <Paragraph className='text-paragraph error mb-auto'>
                <a href='/logout' className='error'>
                  Logout
                </a>
              </Paragraph>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SubscriptionExpiredContent);
